var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let FormStepper = class FormStepper extends LitElement {
    constructor() {
        super(...arguments);
        this.currentStep = 1; // Renamed from `step` to match the interface
        this.steps = []; // Ensure `steps` is initialized
    }
    render() {
        return html `
      <div class="timeline">
        ${this.steps.map((step, index) => {
            const position = index + 1;
            const isActive = this.currentStep === position;
            const isDone = position < this.currentStep;
            const clickable = position <= this.currentStep;
            return html `
            <div
              class="step ${isActive ? 'active' : ''} ${isDone
                ? 'done'
                : ''} ${clickable ? 'clickable' : ''}"
              role="button"
              aria-current=${isActive ? 'step' : 'false'}
              @click=${() => this.handleStepClick(position)}
            >
              <span class="dot">${isDone ? this._checkIcon() : position}</span>
              <span class="label" title=${step}>${step}</span>
            </div>
          `;
        })}
      </div>
    `;
    }
    _checkIcon() {
        return html `<svg
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M3.5 8.5 6.5 11.5 12.5 4.5" />
    </svg>`;
    }
    handleStepClick(step) {
        if (step <= this.currentStep) {
            this.dispatchEvent(new CustomEvent('step-change', { detail: step }));
        }
    }
};
FormStepper.styles = css `
    :host {
      display: block;
      font-family: inherit;
      /* Accent kept from the original design; neutrals refreshed. */
      --stepper-accent: #007bff;
      --stepper-accent-soft: rgba(0, 123, 255, 0.12);
      --stepper-track: #e5e7eb;
      --stepper-idle: #9aa0a6;
    }

    .timeline {
      display: flex;
      align-items: flex-start;
      margin-bottom: 18px;
    }

    .step {
      flex: 1 1 0;
      min-width: 0;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 9px;
    }

    /* Connector running from the previous circle's centre to this one's.
       Coloured once the step is reached (active or done). */
    .step:not(:first-child)::before {
      content: '';
      position: absolute;
      top: 13px;
      left: -50%;
      right: 50%;
      height: 2px;
      border-radius: 2px;
      background: var(--stepper-track);
      transition: background 0.2s ease;
      z-index: 0;
    }
    .step.active::before,
    .step.done::before {
      background: var(--stepper-accent);
    }

    .dot {
      position: relative;
      z-index: 1;
      box-sizing: border-box;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      border: 2px solid var(--stepper-track);
      color: var(--stepper-idle);
      font-size: 12px;
      font-weight: 600;
      line-height: 1;
      transition: background 0.2s ease, border-color 0.2s ease,
        color 0.2s ease, box-shadow 0.2s ease;
    }
    .step.active .dot {
      border-color: var(--stepper-accent);
      color: var(--stepper-accent);
      background: #fff;
      box-shadow: 0 0 0 4px var(--stepper-accent-soft);
    }
    .step.done .dot {
      border-color: var(--stepper-accent);
      background: var(--stepper-accent);
      color: #fff;
    }
    .dot svg {
      width: 14px;
      height: 14px;
      display: block;
    }

    .label {
      max-width: 100%;
      font-size: 11.5px;
      font-weight: 500;
      letter-spacing: 0.01em;
      line-height: 1.3;
      text-align: center;
      color: var(--stepper-idle);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      transition: color 0.2s ease;
    }
    .step.active .label {
      color: var(--stepper-accent);
      font-weight: 700;
    }
    .step.done .label {
      color: var(--stepper-accent);
    }

    .step.clickable {
      cursor: pointer;
    }
  `;
__decorate([
    property({ type: Number })
], FormStepper.prototype, "currentStep", void 0);
__decorate([
    property({ type: Array })
], FormStepper.prototype, "steps", void 0);
FormStepper = __decorate([
    customElement('form-stepper')
], FormStepper);
export { FormStepper };
//# sourceMappingURL=FormStepper.js.map